"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _feesSummary = _interopRequireDefault(require("./fees-summary"));
var _levies = _interopRequireDefault(require("./levies"));
var _payouts = _interopRequireDefault(require("./payouts"));
var _summaryHelp = _interopRequireDefault(require("./summary-help"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
class Summary extends _react.Component {
  render() {
    const competition = this.props.competition;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_summaryHelp.default, {
      competitionName: competition.competitionName
    })), !this.props.competition.isAdministratedByUser ? null : /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      md: 6,
      lg: 4
    }, /*#__PURE__*/_react.default.createElement(_feesSummary.default, {
      competition: competition,
      yearID: this.props.match.params.yearID
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      md: 6,
      lg: 3
    }, /*#__PURE__*/_react.default.createElement(_levies.default, {
      competition: competition,
      defaultTiersByYear: this.props.defaultTiersByYear
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      md: 12,
      lg: 5
    }, /*#__PURE__*/_react.default.createElement(_payouts.default, {
      userIsSystemAdmin: this.props.userIsSystemAdmin,
      competition: competition
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref = _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
  isAdministratedByUser: true,
  id: true,
  competitionName: true
}, _feesSummary.default.partialQueries.Competition), _payouts.default.partialQueries.Competition), _levies.default.partialQueries.Competition);
var _ref2 = _mergeBqlQueries({}, _levies.default.partialQueries.DefaultTiersByYear);
var _default = exports.default = (0, _reactBicycle.connect)(Summary, props => ({
  userIsSystemAdmin: true,
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref,
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref2
}));